import { ArrowUpward, KeyboardArrowUp } from "@mui/icons-material";
import { Box, Divider, Grid } from "@mui/material";
import MDTypography from "components/MDTypography";
import parse from "html-react-parser";
import { useMemo } from "react";
import TeamMemberActions from "../TeamMemberActions";

const InterviewTeamMemberRow = ({
  row,
  idx,
  onChangeFeedback,
  onClickRow,
  onOpenNotes,
  selectedApplicant,
  isNotesOpen,
  event,
}) => {
  const { _id, firstName, lastName, email, emailAddress, userType } = row ?? {};

  const notes = useMemo(() => {
    if (!selectedApplicant) return [];
    return (selectedApplicant?.notes ?? []).filter(
      (note) =>
        note.eventUrl === event?.eventUrl &&
        note.createAgent === row?._id &&
        note.type === "Interview Note"
    );
  }, [event?.eventUrl, row?._id, selectedApplicant]);

  const isExternalMember = row.status === "Team Member";

  return (
    <Box>
      <Grid container alignItems="center" spacing={2}>
        <Grid item sm={8.5}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item sm={4}>
              <MDTypography variant="body2">{`${firstName} ${lastName}`}</MDTypography>
            </Grid>
            <Grid item sm={6}>
              <MDTypography variant="body2">{isExternalMember ? email : emailAddress}</MDTypography>
            </Grid>
            <Grid item sm={2}>
              <MDTypography variant="body2">
                {isExternalMember ? "External" : userType}
              </MDTypography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={3.5} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <TeamMemberActions
            id={_id}
            parentComponent="User"
            row={row}
            onChangeFeedback={onChangeFeedback}
            selectedApplicant={selectedApplicant}
            onOpenNotes={onOpenNotes}
            event={event}
            notesDisabled={!notes?.length}
            isExternalMember={isExternalMember}
          />
        </Grid>
      </Grid>
      {isNotesOpen && (
        <Grid container spacing={2}>
          {notes?.length > 0 ? (
            <Grid
              container
              item
              xs={11}
              sx={{
                flexDirection: "column",
                paddingLeft: "28px !important",
              }}
            >
              {notes.map((note, ind) => (
                <>
                  <Divider />
                  <MDTypography variant="body2" color="info">
                    {parse(note.text)}
                  </MDTypography>
                </>
              ))}
            </Grid>
          ) : (
            <Grid
              container
              item
              xs={11}
              sx={{
                flexDirection: "column",
                paddingLeft: "28px !important",
              }}
            >
              <Divider />
              <MDTypography variant="body2" color="info">
                {"< No notes >"}
              </MDTypography>
            </Grid>
          )}
          <Grid
            container
            item
            xs={1}
            sx={{
              alignItems: "flex-end",
            }}
          >
            <KeyboardArrowUp fontSize="large" onClick={() => onOpenNotes(null)} />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default InterviewTeamMemberRow;
